import ComponentBase from './base/component-base';
import ComponentInitializer from '../libs/component-initializer';
import PartsQuantityComponent from './parts/quantity';
import { EVENT_CHANGE_QUANTITY } from '../constants/event';
import Quantity from '../typs/quantity';
import Cart from '../libs/cart';

class CartItemComponent extends ComponentBase {
  protected itemId: string | null = null;
  protected quantityPartsComponent: PartsQuantityComponent | null = null;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  protected init() {
    super.init();

    this.initialize();
    this.setup();
  }

  protected initialize() {
    this.itemId = this.element.dataset.itemId as string;
    const quantityElement = this.element.querySelector(
      '.j-parts-quantity'
    ) as HTMLElement;
    this.quantityPartsComponent = new PartsQuantityComponent(quantityElement);
  }

  protected setup() {
    this.addEventListeners();
  }

  protected addEventListeners() {
    this.quantityPartsComponent?.element.addEventListener(
      EVENT_CHANGE_QUANTITY,
      async (event: Event) => {
        const customEvent = event as CustomEvent<Quantity>;
        try {
          const result = await Cart.update({
            id: this.itemId || '',
            quantity: customEvent.detail.quantity,
          });
          console.log('Cart update result:', result);
        } catch (error) {
          console.error('Failed to update cart:', error);
        }
      }
    );
  }
}

ComponentInitializer.initializeComponent('.j-cart-item', CartItemComponent);
